export const wosBaseUrl = "https://wos.be.thecloudworlds.com/api/private/v1";
export const wosContactMe = wosBaseUrl + "/contact-me";
